import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import { isMobile } from '../utils/MobileCheck';

import { ICourseTopicItem } from '../actions/search';

interface ITreeProps extends React.Props<{}>, ICourseTopicItem {}

interface ITreeState {
	open: boolean;
}

/**
 * トピックツリー
 * @param props
 */
class CareerTopicTree extends React.Component<ITreeProps, ITreeState> {
	public constructor(props: ITreeProps) {
		super(props);

		this.state = {
			open: true,
		};

		this.onClick = this.onClick.bind(this);
	}

	public render() {
		const { treeChildren, level, text } = this.props;
		return (
			<List component="nav" style={{ paddingLeft: level * 8 }}>
				<ListItem button={true} onClick={this.onClick}>
					{isMobile() && (
						<ListItemText
							inset={true}
							primary={text}
							style={{ paddingLeft: '5px' }}
						/>
					)}
					{!isMobile() && (
						<ListItemText inset={true} primary={text} />
					)}
					{treeChildren &&
						treeChildren.length !== 0 &&
						(this.state.open ? <ExpandLess /> : <ExpandMore />)}
				</ListItem>
				{treeChildren &&
					treeChildren.map(
						(node: ICourseTopicItem, i: number): JSX.Element => (
							<Collapse
								key={i}
								in={this.state.open}
								timeout="auto"
								unmountOnExit={true}
							>
								<CareerTopicTree key={i} {...node} />
							</Collapse>
						)
					)}
			</List>
		);
	}

	/**
	 * クリックハンドラ
	 * @param e
	 */
	protected onClick(e: React.MouseEvent<HTMLElement>) {
		this.setState({ open: !this.state.open });
	}
}

export default CareerTopicTree as React.ComponentType<ICourseTopicItem>;



// WEBPACK FOOTER //
// ./src/components/CareerTopicTree.tsx